import styled from 'styled-components'

export const ChartPerformBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
`

export const TypeTabsStyled = styled.div`
  display: flex;
  margin-bottom: 24px;

  .price-type-tab-icon {
    width: 16px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
  }
`
